import { useState, useEffect } from "react";

export const useAdvancedEditorExpression = (standartModeValue?: string | number) => {
  const [editorExpression, handleSetExpression] = useState<string | number>("");

  useEffect(() => {
    handleSetExpression(standartModeValue !== undefined && standartModeValue !== null ? standartModeValue : null);
  }, [standartModeValue]);

  return {
    handleSetExpression,
    editorExpression,
  };
};
